"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftProposalAcceptDto = instanceOfShiftProposalAcceptDto;
exports.ShiftProposalAcceptDtoFromJSON = ShiftProposalAcceptDtoFromJSON;
exports.ShiftProposalAcceptDtoFromJSONTyped = ShiftProposalAcceptDtoFromJSONTyped;
exports.ShiftProposalAcceptDtoToJSON = ShiftProposalAcceptDtoToJSON;
exports.ShiftProposalAcceptDtoToJSONTyped = ShiftProposalAcceptDtoToJSONTyped;
/**
 * Check if a given object implements the ShiftProposalAcceptDto interface.
 */
function instanceOfShiftProposalAcceptDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    return true;
}
function ShiftProposalAcceptDtoFromJSON(json) {
    return ShiftProposalAcceptDtoFromJSONTyped(json, false);
}
function ShiftProposalAcceptDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'nurseProfileId': json['nurseProfileId'],
    };
}
function ShiftProposalAcceptDtoToJSON(json) {
    return ShiftProposalAcceptDtoToJSONTyped(json, false);
}
function ShiftProposalAcceptDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'nurseProfileId': value['nurseProfileId'],
    };
}
//# sourceMappingURL=ShiftProposalAcceptDto.js.map